// base
import { createRoot } from 'react-dom/client';

// App
import App from './App.js';

//styles
import { themeOptions } from 'styles';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './assets/scss/index.scss';

// contexts
import { AlertProvider } from 'contexts';

// providers
import { AlarmProvider, LoadingProvider } from './providers';

// components
import { GlobalStyles } from 'components';

// modules
import { saga } from './modules/rootReducer.js';
import { history, persistor, sagaMiddleware, store } from './modules/store.js';

// libraries
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ConnectedRouter } from 'connected-react-router';
import { CookiesProvider } from 'react-cookie';
import { Provider } from 'react-redux';
import { RecoilRoot } from 'recoil';
import { PersistGate } from 'redux-persist/integration/react';

// dayjs
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { DEFAULT_TIMEZONE } from 'constants/const';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

sagaMiddleware.run(saga);
dayjs.locale('en');
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault(DEFAULT_TIMEZONE);

const rootElement = document.getElementById('root');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      retryOnMount: true,
      refetchOnReconnect: false,
      staleTime: 0,
      throwOnError: false
    },
    mutations: {
      retry: false,
      throwOnError: false,
      onError: (error) => {
        console.log('== Mutation Error == : ', `${error.message}`);
      }
    }
  }
});

if (rootElement) {
  createRoot(rootElement).render(
    <QueryClientProvider client={queryClient}>
      <RecoilRoot>
        <Provider store={store}>
          <PersistGate persistor={persistor}>
            <ConnectedRouter history={history}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <CookiesProvider>
                  <ThemeProvider theme={themeOptions}>
                    <LoadingProvider>
                      <AlarmProvider>
                        <AlertProvider>
                          <GlobalStyles />
                          <ReactQueryDevtools initialIsOpen={false} />

                          <App />
                        </AlertProvider>
                      </AlarmProvider>
                    </LoadingProvider>
                  </ThemeProvider>
                </CookiesProvider>
              </LocalizationProvider>
            </ConnectedRouter>
          </PersistGate>
        </Provider>
      </RecoilRoot>
    </QueryClientProvider>
  );
}
